import { SavedAccountsModalTranslations } from "./saved-accounts-modal-pt-br";

export const SAVED_ACCOUNTS_MODAL_EN_US: SavedAccountsModalTranslations = {
	holderName: "Holder",
	agency: "Agency",
	accountNumber: "Account",
	pixKey: "Pix Key",
	addAccount: "Add Account",
	title: "Saved Accounts",
	search: "Search Account",
	return: "Return",
	default: "Default",
	edit: "Edit",
	delete: "Delete",
};
